export default "__VITE_ASSET__DxqVaHIQ__"